var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 160,
    viewBox: "0 0 228 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 160,
    fill: "#F5F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.977 33.5C104.78 33.5 95.7895 36.2272 88.1426 41.3367C80.4957 46.4461 74.5357 53.7085 71.0162 62.2052C67.4967 70.702 66.5759 80.0516 68.3701 89.0717C70.1643 98.0918 74.593 106.377 81.0961 112.88C87.5993 119.384 95.8848 123.812 104.905 125.607C113.925 127.401 123.275 126.48 131.771 122.96C140.268 119.441 147.53 113.481 152.64 105.834C157.749 98.1871 160.477 89.1968 160.477 80C160.477 73.8935 159.274 67.8468 156.937 62.2052C154.6 56.5636 151.175 51.4374 146.857 47.1195C142.539 42.8016 137.413 39.3764 131.771 37.0396C126.13 34.7027 120.083 33.5 113.977 33.5ZM106.227 95.5V64.5L129.477 80L106.227 95.5Z",
    fill: "#B7BAC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.977 126.5C139.658 126.5 160.477 105.681 160.477 80C160.477 54.3188 139.658 33.5 113.977 33.5C88.2953 33.5 67.4766 54.3188 67.4766 80C67.4766 105.681 88.2953 126.5 113.977 126.5Z",
    stroke: "#B7BAC7",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 80L106.25 64.5V95.5L129.5 80Z",
    stroke: "#B7BAC7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/video-upload.6947d09c1e77762577ad9981369ec515.svg";
export { ForwardRef as ReactComponent };